export const useMaska = () => {
    const unmaskNumbers = (masked_value: string): string => {
        const unmasked_value = masked_value.replace(/[^\d]/g, '')
        return unmasked_value
    }

    return { unmaskNumbers }
}
